/* eslint max-len: off */
import React from 'react';

import type { SvgProps } from '../enums';

export const ChatMessage: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.11781 6.88213C8.1829 6.94722 8.1829 7.05275 8.11781 7.11784C8.05272 7.18292 7.9472 7.18292 7.88211 7.11784C7.81702 7.05275 7.81702 6.94722 7.88211 6.88213C7.9472 6.81705 8.05272 6.81705 8.11781 6.88213"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.11781 6.88213C5.1829 6.94722 5.1829 7.05275 5.11781 7.11784C5.05272 7.18292 4.9472 7.18292 4.88211 7.11784C4.81702 7.05275 4.81702 6.94722 4.88211 6.88213C4.9472 6.81705 5.05272 6.81705 5.11781 6.88213"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1178 6.88213C11.1829 6.94722 11.1829 7.05275 11.1178 7.11784C11.0527 7.18292 10.9472 7.18292 10.8821 7.11784C10.817 7.05275 10.817 6.94722 10.8821 6.88213C10.9472 6.81705 11.0527 6.81705 11.1178 6.88213"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 10.67V3.33333C2 2.96533 2.29867 2.66667 2.66667 2.66667H13.3333C13.7013 2.66667 14 2.96533 14 3.33333V13.3333L10.0607 11.3733L2.66333 11.3367C2.29667 11.3347 2 11.0367 2 10.67Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
